<!-- content from style guide, expectation by default is empty span -->
<span class="overview-summary-label"></span>
<!--  -->
<div class="overview-table-height {{ sectionclass }}" [ngClass]="{ entravision: isEntravisionR103 }">
	<div class="c-portlet u-bg-main u-shadow-mini pos-relative">
		<app-loader [showLoader]="showLoad"></app-loader>
		<div class="c-portlet__content" style="padding: 1rem">
			<table class="accordion-table">
				<thead style="border-left: 5px solid #efefef">
					<tr>
						<!-- content from style guide, expectation by default is empty span -->
						<th style="display: none"><span class="table-header_label"></span></th>
						<!--  -->
						<th class="overview-product"></th>
						<th *ngIf="hasExposureColumn"><span class="table-header_label">Exposures</span></th>
						<th style="display: none" class="Exposers-element"><span class="table-header_label">Exposures</span></th>
						<th><span class="table-header_label">Impressions</span></th>
						<th><span class="table-header_label">Clicks</span></th>
						<th><span class="table-header_label">View Throughs</span></th>
						<th><span class="table-header_label">Visits</span></th>
					</tr>
				</thead>
				<tbody>
					<tr
						*ngFor="let summaryObj of summaryData"
						class="header-level {{ summaryObj.productName }}"
						[ngClass]="{
							'product-parent': summaryObj.isParent,
							'product-child': !summaryObj.isParent
						}"
					>
						<td
							class="{{ summaryObj.parentClass }}"
							[ngClass]="{
								'display-header_border overview-header': summaryObj.isParent,
								'display-subHead_border overview-subheader': !summaryObj.isParent
							}"
						>
							<span [innerHtml]="summaryObj.productName"></span>
						</td>
						<td
							*ngIf="hasExposureColumn"
							[ngClass]="{
								'table-header_label overview-header': summaryObj.isParent,
								'overview-subheader': !summaryObj.isParent
							}"
						>
							<span *ngIf="summaryObj.exposures && !isNaN(summaryObj.exposures); else exposuresBlock">{{
								summaryObj.exposures | number
							}}</span>
							<ng-template #exposuresBlock>
								<span>n/a</span>
							</ng-template>
						</td>
						<td
							style="display: none"
							class="Exposers-element"
							[ngClass]="{
								'table-header_label overview-header': summaryObj.isParent,
								'overview-subheader': !summaryObj.isParent
							}"
						>
							<span *ngIf="summaryObj.exposures && !isNaN(summaryObj.exposures); else exposuresBlock">{{
								summaryObj.exposures | number
							}}</span>
							<ng-template #exposuresBlock>
								<span>n/a</span>
							</ng-template>
						</td>
						<td
							*ngIf="isR1 || isR101 || isR104 || isR103 || isR102 || isR8"
							[ngClass]="{
								'table-header_label overview-header': summaryObj.isParent,
								'overview-subheader': !summaryObj.isParent
							}"
						>
							<span *ngIf="!isNaN(summaryObj.impressions); else impressionsBlock"
								>{{ summaryObj.impressions | number }}
							</span>
							<ng-template #impressionsBlock>
								<span>n/a</span>
							</ng-template>
						</td>
						<td
							[ngClass]="{
								'table-header_label overview-header': summaryObj.isParent,
								'overview-subheader': !summaryObj.isParent
							}"
						>
							<span *ngIf="!isNaN(summaryObj.clicks); else clicksBlock">
								<span
									appTooltip
									title="Tooltip"
									[title]="'Click Rate : ' + summaryObj.clickRate"
									data-size="big"
									[options]="tooltipOptions"
								>
									{{ summaryObj.clicks | number }}
								</span>
							</span>
							<ng-template #clicksBlock>
								<span
									appTooltip
									title="Tooltip"
									[title]="'Click Rate : ' + isR8 ? 'N/A' : 'n/a'"
									data-size="big"
									[options]="tooltipOptions"
									>n/a</span
								>
							</ng-template>
						</td>
						<td
							[ngClass]="{
								'table-header_label overview-header': summaryObj.isParent,
								'overview-subheader': !summaryObj.isParent
							}"
						>
							<span *ngIf="!isNaN(summaryObj.viewThroughs); else viewThroughBlock">
								<span
									appTooltip
									title="Tooltip"
									[title]="'View Through Rate : ' + summaryObj.viewThroughRate"
									data-size="big"
									[options]="tooltipOptions"
								>
									{{ summaryObj.viewThroughs | number }}
								</span>
							</span>
							<ng-template #viewThroughBlock>
								<span
									appTooltip
									title="Tooltip"
									[title]="'View Through Rate : ' + isR8 ? 'N/A' : 'n/a'"
									data-size="big"
									[options]="tooltipOptions"
									>n/a</span
								>
							</ng-template>
						</td>
						<td
							[ngClass]="{
								'table-header_label overview-header': summaryObj.isParent,
								'overview-subheader': !summaryObj.isParent
							}"
						>
							<span *ngIf="!isNaN(summaryObj.visits); else visitsBlock">
								<span
									appTooltip
									title="Tooltip"
									[title]="'Visit Rate : ' + summaryObj.visitRate"
									data-size="big"
									[options]="tooltipOptions"
								>
									{{ summaryObj.visits | number }}
								</span>
							</span>
							<ng-template #visitsBlock>
								<span
									appTooltip
									title="Tooltip"
									[title]="'Visit Rate : ' + isR8 ? 'N/A' : 'n/a'"
									data-size="big"
									[options]="tooltipOptions"
									>n/a</span
								>
							</ng-template>
						</td>
					</tr>
					<tr *ngIf="summaryData.length == 0">
						<td [attr.colspan]="hasExposureColumn ? 6 : 5" style="height: 17em" class="overview-summary-no-data">
							<span>No Data to Display</span>
						</td>
						<td
							style="display: none"
							class="Exposers-element"
							[attr.colspan]="6"
							style="height: 17em"
							class="overview-summary-no-data"
						>
							<span>No Data to Display</span>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</div>
